// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getForceStarted(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/forcestart/artifacts`);
}
